import { Button } from '@rneui/themed';
import React, { FC } from 'react';
import type { IShaButtonProps } from './interface';

const ShaButton: FC<IShaButtonProps> = (props) => {
  return (
    <Button {...props}>{props.children ? props.children : props.title}</Button>
  );
};

export default ShaButton;
